import { Dropdown } from '@rd-web-markets/shared/dist/util';
import React, { useEffect, useState } from 'react';
import companyProjectsService from '../services/company/all_projects_with_missions.service';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
const ResubmissionProjectSelectDropdown = _ref => {
  let {
    report,
    handleChange,
    handleSubmit,
    loading,
    setLoading,
    companyId
  } = _ref;
  const {
    t
  } = useTranslation();
  const [companyProjects] = companyProjectsService.useFetchCompanyProjects(companyId, setLoading);
  const [options, setOptions] = useState([]);
  const makeResponseOptions = useCallback(() => {
    const optionsMapped = companyProjects.map(p => {
      return {
        key: p.id,
        text: p.project_name,
        value: JSON.stringify({
          id: p.id,
          project_name: p.project_name
        })
      };
    });
    setOptions([...optionsMapped]);
  }, [companyProjects]);
  useEffect(() => {
    if (!!companyProjects.length) {
      makeResponseOptions();
    }
  }, [makeResponseOptions, companyProjects]);
  if (loading) return /*#__PURE__*/React.createElement("div", null, t('please_wait_while_company_projects_are_being_retrieved'));
  return /*#__PURE__*/React.createElement(Dropdown, {
    dataTestId: "resubmission_project_select",
    name: "resubmission_project",
    value: report.resubmission_project,
    onChange: handleChange,
    options: options,
    passEntireEvent: true,
    onBlur: handleSubmit
  });
};
export default ResubmissionProjectSelectDropdown;